// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1RWsE","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__314oE"};